import { render, staticRenderFns } from "./AddressSeclect.vue?vue&type=template&id=b124ebc8&scoped=true"
import script from "./AddressSeclect.vue?vue&type=script&lang=js"
export * from "./AddressSeclect.vue?vue&type=script&lang=js"
import style0 from "./AddressSeclect.vue?vue&type=style&index=0&id=b124ebc8&prod&lang=scss&scoped=true"
import style1 from "./AddressSeclect.vue?vue&type=style&index=1&id=b124ebc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b124ebc8",
  null
  
)

export default component.exports